export class RatePurpose {
    id: number;
    purpose: string;
}

export class RateField {
    fieldOrigin: number;
    externalId: number;
    externalValue: string;
}

export class SupplierRatingAttachment {
    id: number;
    supplierRatingId: number;
    fileName: string;
    storageKey: string;
}

export class SupplierRating {
    id: number;
    supplierCode: string;
    ratePurposeId: number;
    ratePurpose: string;
    subject: string;
    note: string;
    rate: number;
    rateFields: RateField[] = [];
    attachments: SupplierRatingAttachment[] = [];
    createdBy: string;
    createdOn: Date | null = null;

    newFiles: File[] = [];
}
